export enum StudentPassConditionTabName {
  NONE = 1,
  PASS = 2,
  RATING_SYSTEM = 3,
}
